"use client";

import { c as _c } from "react/compiler-runtime";
import { LogOut } from "lucide-react";
import { Button } from "@/shared/ui/button";
import { logout } from "@/core/auth/auth-api";
import { useAsyncAction } from "@/shared/hooks/use-async-action";
import { cn } from "@/shared/lib/utils";
interface LogoutButtonProps {
  className?: string;
  label?: string;
  loadingLabel?: string;
  redirectTo?: string;
  showLabel?: boolean;
  variant?: "default" | "outline" | "secondary" | "ghost";
}
export function LogoutButton(t0) {
  const $ = _c(17);
  const {
    className,
    label: t1,
    loadingLabel: t2,
    redirectTo: t3,
    showLabel: t4,
    variant: t5
  } = t0;
  const label = t1 === undefined ? "Logout" : t1;
  const loadingLabel = t2 === undefined ? "Signing out..." : t2;
  const redirectTo = t3 === undefined ? "/" : t3;
  const showLabel = t4 === undefined ? true : t4;
  const variant = t5 === undefined ? "outline" : t5;
  const logoutAction = useAsyncAction();
  let t6;
  if ($[0] !== logoutAction || $[1] !== redirectTo) {
    t6 = async function handleLogout() {
      const result = await logoutAction.run(async () => {
        const response = await logout(redirectTo);
        return {
          logoutUrl: response.logoutUrl
        };
      });
      if (!result?.logoutUrl) {
        return;
      }
      window.location.assign(result.logoutUrl);
    };
    $[0] = logoutAction;
    $[1] = redirectTo;
    $[2] = t6;
  } else {
    t6 = $[2];
  }
  const handleLogout = t6;
  let t7;
  if ($[3] !== className) {
    t7 = cn("gap-2 rounded-full", className);
    $[3] = className;
    $[4] = t7;
  } else {
    t7 = $[4];
  }
  let t8;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <LogOut className="size-4" />;
    $[5] = t8;
  } else {
    t8 = $[5];
  }
  const t9 = showLabel && (logoutAction.state.loading ? loadingLabel : label);
  let t10;
  if ($[6] !== handleLogout || $[7] !== logoutAction.state.loading || $[8] !== t7 || $[9] !== t9 || $[10] !== variant) {
    t10 = <Button className={t7} disabled={logoutAction.state.loading} onClick={handleLogout} variant={variant}>{t8}{t9}</Button>;
    $[6] = handleLogout;
    $[7] = logoutAction.state.loading;
    $[8] = t7;
    $[9] = t9;
    $[10] = variant;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  if ($[12] !== logoutAction.state.error) {
    t11 = logoutAction.state.error ? <p className="text-sm text-red-600">{logoutAction.state.error.message}</p> : null;
    $[12] = logoutAction.state.error;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] !== t10 || $[15] !== t11) {
    t12 = <div className="space-y-2">{t10}{t11}</div>;
    $[14] = t10;
    $[15] = t11;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  return t12;
}